import React, { useState } from "react";
import { getSelectedFilterItemArr } from "../../utils/UtilityMethod";
import CatalogFilterCbItemGroup from "./CatalogFilterCbItemGroup";

function CatalogFilterMain({ filter, onFilterCbClick, filterQs }) {

  const cbItemTitle = filter?.name + "|" + filter?.id || "";
  const choiceType = filter?.choice_type || "";
  const cbItemDetails = { choice_type: choiceType, title: cbItemTitle };
  const [searchValueObj, setSearchValueObj] = useState({});

  // let filtersSelectedArr = getSelectedFilterItemArr(searchParams.get("f") || "");
  let filtersSelectedArr = getSelectedFilterItemArr(filterQs);

  const onSearchFilter = (filterId, searchValue) => {
    let exObj = {...searchValueObj};   
    exObj[filterId] = searchValue;
    let div_name = "vss_filter_"+filterId+"_div";
    if(searchValue === ""){
      window.$("#"+div_name+ " button").addClass('collapsed');
      window.$("#"+div_name+ " button").attr("aria-expanded","false");
      window.$("#"+div_name+ " div").removeClass('show');    
    }else{
      window.$("#"+div_name+ " button").removeClass('collapsed');
      window.$("#"+div_name+ " button").attr("aria-expanded","true");
      window.$("#"+div_name+ " div").addClass('show');
    }
    setSearchValueObj(exObj);
  }

  const resetSearchInput = (filterId) => {
    let exObj = {...searchValueObj};   
    delete exObj[filterId];
    let div_name = "vss_filter_"+filterId+"_div";    
    window.$("#"+div_name+ " button").addClass('collapsed');
    window.$("#"+div_name+ " button").attr("aria-expanded","false");
    window.$("#"+div_name+ " div").removeClass('show');
    setSearchValueObj(exObj);
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={filter.id + "_heading"}>
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={"#" + filter.id}
          aria-expanded="false"
          aria-controls={filter.id}
        >
          {filter?.title}
        </button>
      </h2>
      <div
        id={filter.id}
        className="accordion-collapse inr-drpdwn collapse"
        aria-labelledby={filter.id + "_heading"}
        data-bs-parent="#main_dropdown"
      >
        <div className="accordion-body">
          <div className="search-box input-group">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/icons/search-icon.png"
              }
              className="input-icon-search filter-icon-search img-fluid d-block"
              alt=""
            />
            <input
              type="text"
              className="form-control"
              value={searchValueObj[filter.id] || ""}
              onChange={(e) => onSearchFilter(filter.id, e.target.value)}
              placeholder={
                "Type " + filter.title.toString().toLowerCase() + " name here"
              }
              id={"vss_search_"+filter.title.toString().toLowerCase()}

            />

            {searchValueObj[filter.id] && (
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/Cross-Button.png"
                }
                className="header-icon-cross img-fluid d-block search-cross-btn"
                alt=""
                onClick={(e) => {
                  resetSearchInput(filter.id);
                }}
              />
            )}
          </div>
          <div className="search-fixed-body">
            {
            /**
             * @BOC
             * @Support #157051-Implement Changes On Staging Server Such that Filters are Listed on Category Page from Typesense
             * @author Mohammad Meraj
             * @date 02-Jan-2025
             * @use_of_code: The size condition has been removed from the code because the segregation of sizes from the filters has been eliminated.
             * Sizes are now included as regular filters, just like other attributes.As a result, there is no longer a need to handle the size filter separately in the code.
             * This update simplifies the logic and ensures all filters, including sizes, are processed uniformly.
             */
            (filter.header_items?.length === 1) ? (
              <CatalogFilterCbItemGroup
                filterItems={filter.header_items[0].items}
                searchValueObj={searchValueObj}
                filterId={filter.id}
                onFilterCbClick={onFilterCbClick}
                filtersSelectedArr={filtersSelectedArr}
                cbItemDetails={cbItemDetails}
              />
            ) : (
              <div
                className="accordion accordion-flush inner-dropdown"
                id={filter.id + "-sub-dropdown"}
              >
                {filter.header_items?.map((headerItems1, index) => {
                  return (
                    <div className="accordion-item" key={index} id={"vss_filter_"+filter.id+"_div"}>
                      <h2
                        className="accordion-header"
                        id={filter.id + "-sub-" + index}
                      >
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={
                            "#" + filter.id + "-sub-" + index + "-collapse"
                          }
                          aria-expanded="false"
                          aria-controls={
                            filter.id + "-sub-" + index + "-collapse"
                          }
                        >
                          {headerItems1?.heading}
                        </button>
                      </h2>
                      <div
                        id={filter.id + "-sub-" + index + "-collapse"}
                        className="accordion-collapse collapse"
                        aria-labelledby={filter.id + "-sub-" + index}
                        data-bs-parent={"#" + filter.id + "-sub-dropdown"}
                      >
                        {headerItems1.header_items &&
                        headerItems1.header_items.length > 0 ? (
                          <>
                            {headerItems1.header_items?.map(
                              (headerItems2, index) => {
                                return (
                                  <div key={index}>
                                    {headerItems1.header_items.length > 1 && (
                                      <h3 className="inner-cb-group-heading">
                                        <span>{headerItems2.heading}</span>
                                      </h3>
                                    )}
                                    <CatalogFilterCbItemGroup
                                      filterItems={headerItems2.items}
                                      searchValueObj={searchValueObj}
                                      filterId={filter.id}
                                      onFilterCbClick={onFilterCbClick}
                                      filtersSelectedArr={filtersSelectedArr}
                                      cbItemDetails={cbItemDetails}
                                    />
                                  </div>
                                );
                              }
                            )}
                          </>
                        ) : (
                          <CatalogFilterCbItemGroup
                            filterItems={headerItems1.items}
                            searchValueObj={searchValueObj}
                            filterId={filter.id}
                            onFilterCbClick={onFilterCbClick}
                            filtersSelectedArr={filtersSelectedArr}
                            cbItemDetails={cbItemDetails}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CatalogFilterMain;
